"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketApi = exports.MarketCategoryCode = exports.ProductCategoryCode = exports.InputCurrencyCode = exports.CurrencyCode = exports.TrendCode = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var TrendCode;
(function (TrendCode) {
    TrendCode["Increase"] = "increase";
    TrendCode["Decrease"] = "decrease";
    TrendCode["Normal"] = "normal";
})(TrendCode = exports.TrendCode || (exports.TrendCode = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["Gbp"] = "gbp";
    CurrencyCode["Usd"] = "usd";
})(CurrencyCode = exports.CurrencyCode || (exports.CurrencyCode = {}));
var InputCurrencyCode;
(function (InputCurrencyCode) {
    InputCurrencyCode["Eur"] = "eur";
})(InputCurrencyCode = exports.InputCurrencyCode || (exports.InputCurrencyCode = {}));
var ProductCategoryCode;
(function (ProductCategoryCode) {
    ProductCategoryCode["Crops"] = "crops";
    ProductCategoryCode["Cattle"] = "cattle";
    ProductCategoryCode["Pork"] = "pork";
    ProductCategoryCode["CattleFood"] = "cattleFood";
    ProductCategoryCode["Energies"] = "energies";
    ProductCategoryCode["CommoditiesFutures"] = "commoditiesFutures";
})(ProductCategoryCode = exports.ProductCategoryCode || (exports.ProductCategoryCode = {}));
var MarketCategoryCode;
(function (MarketCategoryCode) {
    MarketCategoryCode["ClockMarket"] = "clockMarket";
    MarketCategoryCode["CounterMarketCounter"] = "counterMarketCounter";
    MarketCategoryCode["ClockReferenceMarket"] = "clockReferenceMarket";
    MarketCategoryCode["CounterReferenceMarketCounter"] = "counterReferenceMarketCounter";
})(MarketCategoryCode = exports.MarketCategoryCode || (exports.MarketCategoryCode = {}));
function MarketApiAxiosParamCreator(configuration) {
    return {
        getAnalysis(productTypeId, marketId, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getAnalysis.");
            }
            const localVarPath = `/product-types/{productTypeId}/analyses`.replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (marketId !== undefined) {
                localVarQueryParameter["marketId"] = marketId;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLastAnalysis(options = {}) {
            const localVarPath = '/last-analyses';
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAnalysisTallage(productTypeId, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getAnalysisTallage.");
            }
            const localVarPath = `/product-types/{productTypeId}/analysesTallage?`.replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLastAnalysisTallage(options = {}) {
            const localVarPath = '/last-analyses-tallage';
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCurrency(currencyCode, options = {}) {
            if (currencyCode === null || currencyCode === undefined) {
                throw new base_1.RequiredError("currencyCode", "Required parameter currencyCode was null or undefined when calling getCurrency.");
            }
            const localVarPath = `/currencies/{currencyCode}`.replace(`{${"currencyCode"}}`, encodeURIComponent(String(currencyCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMarkets(productCategoryCode, options = {}) {
            const localVarPath = `/markets`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (productCategoryCode !== undefined) {
                localVarQueryParameter["productCategoryCode"] = productCategoryCode;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProduct(productTypeId, productId, shouldGapFill, quoteDate, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getProduct.");
            }
            if (productId === null || productId === undefined) {
                throw new base_1.RequiredError("productId", "Required parameter productId was null or undefined when calling getProduct.");
            }
            const localVarPath = `/product-types/{productTypeId}/products/{productId}`
                .replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (shouldGapFill !== undefined) {
                localVarQueryParameter["shouldGapFill"] = shouldGapFill;
            }
            if (quoteDate !== undefined) {
                localVarQueryParameter["quoteDate"] = quoteDate.toISOString();
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProductType(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getProductType.");
            }
            const localVarPath = `/product-types/{productTypeId}`.replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (marketId !== undefined) {
                localVarQueryParameter["marketId"] = marketId;
            }
            if (shouldGapFill !== undefined) {
                localVarQueryParameter["shouldGapFill"] = encodeURIComponent(String(shouldGapFill ? "1" : "0"));
            }
            if (isReferenceMarket !== undefined) {
                localVarQueryParameter["isReferenceMarket"] = isReferenceMarket;
            }
            if (quoteDate !== undefined) {
                localVarQueryParameter["quoteDate"] = quoteDate.toISOString();
            }
            if (productCategoryCode !== undefined) {
                localVarQueryParameter["productCategoryCode"] = productCategoryCode;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProductTypes(marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options = {}) {
            const localVarPath = `/product-types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (marketId !== undefined) {
                localVarQueryParameter["marketId"] = marketId;
            }
            if (shouldGapFill !== undefined) {
                localVarQueryParameter["shouldGapFill"] = shouldGapFill;
            }
            if (isReferenceMarket !== undefined) {
                localVarQueryParameter["isReferenceMarket"] = isReferenceMarket;
            }
            if (productCategoryCode !== undefined) {
                localVarQueryParameter["productCategoryCode"] = productCategoryCode;
            }
            if (quoteDate !== undefined) {
                localVarQueryParameter["quoteDate"] = quoteDate.toISOString();
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProducts(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getProducts.");
            }
            const localVarPath = `/product-types/{productTypeId}/products`.replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (marketId !== undefined) {
                localVarQueryParameter["marketId"] = marketId;
            }
            if (shouldGapFill !== undefined) {
                localVarQueryParameter["shouldGapFill"] = shouldGapFill;
            }
            if (isReferenceMarket !== undefined) {
                localVarQueryParameter["isReferenceMarket"] = isReferenceMarket;
            }
            if (productCategoryCode !== undefined) {
                localVarQueryParameter["productCategoryCode"] = productCategoryCode;
            }
            if (quoteDate !== undefined) {
                localVarQueryParameter["quoteDate"] = quoteDate.toISOString();
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getQuotes(productTypeId, productId, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getQuotes.");
            }
            if (productId === null || productId === undefined) {
                throw new base_1.RequiredError("productId", "Required parameter productId was null or undefined when calling getQuotes.");
            }
            const localVarPath = `/product-types/{productTypeId}/products/{productId}/quotes`
                .replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBoxLinksCattle(options = {}) {
            const localVarPath = '/market-boxlinks';
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function MarketApiFp(configuration) {
    return {
        getAnalysis(productTypeId, marketId, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getAnalysis(productTypeId, marketId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getLastAnalysis(options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getLastAnalysis(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getAnalysisTallage(productTypeId, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getAnalysisTallage(productTypeId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getLastAnalysisTallage(options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getLastAnalysisTallage(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getCurrency(currencyCode, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getCurrency(currencyCode, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getMarkets(productCategoryCode, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getMarkets(productCategoryCode, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getProduct(productTypeId, productId, shouldGapFill, quoteDate, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getProduct(productTypeId, productId, shouldGapFill, quoteDate, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getProductType(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getProductType(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getProductTypes(marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getProductTypes(marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getProducts(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getProducts(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getQuotes(productTypeId, productId, options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getQuotes(productTypeId, productId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getBoxLinksCattle(options) {
            const localVarAxiosArgs = MarketApiAxiosParamCreator(configuration).getBoxLinksCattle(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class MarketApi extends base_1.BaseAPI {
    getAnalysis(productTypeId, marketId, options) {
        return MarketApiFp(this.configuration).getAnalysis(productTypeId, marketId, options)(this.axios, this.basePath);
    }
    getLastAnalysis(options) {
        return MarketApiFp(this.configuration).getLastAnalysis(options)(this.axios, this.basePath);
    }
    getAnalysisTallage(productTypeId, options) {
        return MarketApiFp(this.configuration).getAnalysisTallage(productTypeId, options)(this.axios, this.basePath);
    }
    getLastAnalysisTallage(options) {
        return MarketApiFp(this.configuration).getLastAnalysisTallage(options)(this.axios, this.basePath);
    }
    getCurrency(currencyCode, options) {
        return MarketApiFp(this.configuration).getCurrency(currencyCode, options)(this.axios, this.basePath);
    }
    getMarkets(productCategoryCode, options) {
        return MarketApiFp(this.configuration).getMarkets(productCategoryCode, options)(this.axios, this.basePath);
    }
    getProduct(productTypeId, productId, shouldGapFill, quoteDate, options) {
        return MarketApiFp(this.configuration).getProduct(productTypeId, productId, shouldGapFill, quoteDate, options)(this.axios, this.basePath);
    }
    getProductType(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options) {
        return MarketApiFp(this.configuration).getProductType(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options)(this.axios, this.basePath);
    }
    getProductTypes(marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options) {
        return MarketApiFp(this.configuration).getProductTypes(marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options)(this.axios, this.basePath);
    }
    getProducts(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options) {
        return MarketApiFp(this.configuration).getProducts(productTypeId, marketId, shouldGapFill, isReferenceMarket, productCategoryCode, quoteDate, options)(this.axios, this.basePath);
    }
    getQuotes(productTypeId, productId, options) {
        return MarketApiFp(this.configuration).getQuotes(productTypeId, productId, options)(this.axios, this.basePath);
    }
    getBoxLinksCattle(options) {
        return MarketApiFp(this.configuration).getBoxLinksCattle(options)(this.axios, this.basePath);
    }
}
exports.MarketApi = MarketApi;
